import { googleLogout } from '@react-oauth/google';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { impersonateUserCookieStorage, userCookieStorage } from 'core/authentification';
import { destroyStore } from 'store/destroy-store';
import { destroyFlowControl } from 'core/flow-control/flow-control';
import { useAppDispatch } from 'store/app-store-hooks';
import { webViewTokenSignal } from 'features/mobile-report/state/mobile-report.signals';

export const useInvalidateUser = () => {
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const history = useHistory();

    return useCallback(
        (resetAppToken = true) => {
            if (resetAppToken) {
                webViewTokenSignal.value = undefined;
                window.placerMobile?.token.reset();
            }
            googleLogout();
            userCookieStorage.removeUser();
            impersonateUserCookieStorage.removeUser();
            queryClient.clear();
            dispatch(destroyStore());
            destroyFlowControl();
            history.replace('/', null);
        },
        [dispatch, history, queryClient],
    );
};
